import getCurrency from './getCurrency';

const isBTC = (currency: string) => getCurrency(currency) === 'BTC';

export default isBTC;
